module.exports = __webpack_public_path__ + "media/img/Custom_OC-516badd5.png";